export enum FeedbackType {
  Appreciation = 'Appreciation',
  FeatureRequest = 'FeatureRequest',
  BugReport = 'BugReport',
  Others = 'Others',
}
